define('modules/dashboardmenu/js/base.js',["app/module","app/config","app/user","jquery","app/util","templates","app/forms","jquery.cookie","bootstrap/popover"], function(module,config,user,$,util,templates,forms) {
    return new module({
        name: 'dashboardmenu',
        selectors: '.mainMenuWrap',
        remoteData: [],

        config: {
            // TODO - Set up the proper or combined modal mode
            // TODO - Set up the data-attr apply config method
            mode: 'sidebaronly', // Two modes - full or sidebaronly
            pushPageContent: 'left', // Opening the menu pushes the page content to the left/right, defaults to left
            hoverMenuEnabled: false, // TODO - This is not implemented in any logic below
            formLocation: null,
            hideMenuOnForms: false,
            openRoutes: ['register','login','forgot','reset'] // Default for forms
        },

        routes: [{
            route: '.*',
            fn: function(hash){
                if(!this.getConfig().formLocation) {
                    this.updateToggleMenu(false);
                } else if(this.getConfig().openRoutes.indexOf(hash.split('/')[0]) == -1) {
                    if(this.appLoaded) {
                        this.updateToggleMenu(false);
                    } else {
                        this.appLoaded = true;
                    }
                }
            },
            extra: true,
            delay: 150
        },{
            route: 'menu',
            fn: 'routeDashboardLinks',
            extra: true
        },{
            route: 'register',
            fn: 'routeRegister',
            silent: true,
            delay: 200
        },{
            route: 'login',
            fn: 'routeLogin',
            silent: true,
            delay: 200
        },{
            route: 'forgot',
            fn: 'routeForgot',
            silent: true,
            delay: 200
        },{
            route: 'reset',
            fn: 'routeReset',
            silent: true,
            delay: 200
        }],

        initialize: function (data) {

            // Render the template
            $('.mainMenuWrap').append(templates.dashboardmenu());

            if(this.getConfig().mode == 'sidebaronly') {
                $('.mainMenuWrap').find('#actionMenu, #centerMenuContent').remove();
            }

            if(this.getConfig().hideMenuOnForms) {
                $(this.getConfig().formLocation).hide();
            }

            var mainMenu = $('#mainMenu');

            // Only applies if the mainMenu is present
            if(mainMenu.length > 0) {

                if(user.checkRole('loggedin')) {
                    if(!this.getConfig().hideMenuOnForms) {
                        this.updateToggleMenu(templates.dashboardlinks());
                        $('#actionMenu').toggleClass('dashboardLinksShown',true);
                    }
                    // If the user is logged in, update the days left to submit and logout link
                    $('#mainNavbar a[href*="login"]').text('Logout').attr('href','/logout.aspx');
                    if(config.rampitSubTimeLeft >= 0) {
                        $('#mainNavbar a[href*="register"]').html('<span class="dayLeft"></span> Days to Submit').attr('href','#');
                    }
                } else if(user.checkRole('registered')) {
                    if(!this.getConfig().hideMenuOnForms) {
                        this.updateToggleMenu(templates.login(config.regConfig));
                        $('#actionMenu').toggleClass('loginShown',true);
                    }
                } else {
                    if(!this.getConfig().hideMenuOnForms) {
                        this.updateToggleMenu(templates.register(config.regConfig));
                        $('#actionMenu').toggleClass('registerShown',true);
                    }
                }

                // Detect and handle close button
                $('.dashboardToggle, #mainMenu .closeWrap').on('click',$.proxy(function(e){
                    e.preventDefault();
                    this.updateToggleMenu(!$('#mainMenu').is(':visible'),false);
                    return false;
                },this));

                // Add body listener for menu status control
                $('body').on('updatedashboard',$.proxy(function(e,a,b,c){
                    this.updateToggleMenu(a,b,c);
                },this));

            }

            // Handle the hash routing for the main menu
            // TODO - Important - we need to reimplement this into routing methods and also handle situations where both modals and navmenu are being used
            if(this.getConfig().mode == 'full') {
                $(window).hashchange($.proxy(function () {
                    if (window.bRampit) {
                        rampitInit(location.hash.substr(1));
                    }
                }, this));
            }

            // Navbar flyout
            $('.partnerLink, .partnerFlyout .closeBtn').click(function(e){
                e.preventDefault();
                $('.partnerFlyout').toggleClass('masked');
                setTimeout(function(){
                    $('.partnerFlyout').toggleClass('open');
                    $('.introPage').toggleClass('bumpLeft');
                },50);
            });

            $('.flyoutTrigger, .rightFlyout .closeBtn, .leftFlyout .closeBtn').click(function(e){
                e.preventDefault();
                var flyoutEl = $(this).attr('data-flyout') || $(this).parents('.rightFlyout, .leftFlyout');
                $(flyoutEl).toggleClass('masked');
                setTimeout(function(){
                    $(flyoutEl).toggleClass('open');
                    $('.introPage').toggleClass('bumpRight');
                },50);
            });

            // Add tooltip dropdown support about button
            /*var popoverHtml = $('<ul class="aboutPopoverList"><li><a href="about.html">About</a></li><li><a href="#">About Two</a></li></ul>');
             $('.aboutHoverBtn').hover(function(){
             $(this).focus();
             }).popover({
             content: popoverHtml,
             html: true,
             placement: 'bottom',
             container: 'nav',
             trigger: 'focus',
             delay: {
             show: 0,
             hide: 250
             }
             });*/
        },

        methods: {

            updateToggleMenu: function (open, content, location) {

                // Check if we are just passing content, in which case do it silently
                if (typeof open == 'string' || typeof open == 'object') {
                    content = open;
                    open = null;
                }

                // Fire a global app event for open/close status
                if (open) {
                    $('body').trigger('mainnavopen');
                } else {
                    $('body').trigger('mainnavclose');
                }

                if(this.getConfig().hideMenuOnForms && this.getConfig().formLocation) {
                    $(this.getConfig().formLocation).hide();
                    $('#sideMenu').show();
                }

                if ($('#mainMenu').length > 0) {

                    // Reset visible elements
                    $('#mainMenu .actionContent').show(); //, #mainMenu .daysPromo').show();
                    $('#actionMenu').removeClass('hasMessage largeSuccess');

                    // Set the template content
                    if (content) {
                        var location = this.getConfig()['formLocation'];
                        if(location) {
                            $(location).html(content);
                            $(location).show();
                        } else {
                            $('#mainMenu .actionContent').html(content);
                        }
                    }

                    // Trigger the opening animation
                    if (open !== null) {
                        if (open == false) {
                            $('.navbarWrap').removeClass('move');
                            $('.navbar .navbar-header').removeClass('hideNav');
                            $('#mainMenu').addClass('closing');
                            $('#mainMenu').removeClass('open');
                            //$('.navbarWrap').addClass('slideUpOut');
                            $('.daysToRegister').removeClass('mobileNavVisible');
                            $('.hamburger-to-close').removeClass('changeclose');
                            $('.dashboardToggle').removeClass('open');
                            $('.sidebar-item').removeClass('sidebar-item-selected');
                            $('.dashboard-footer-menu').fadeOut();
                            $('.dashboard-menu-text').text('Menu');
                            $('.singlePageWrap').removeClass('pushContentLeft pushContentRight');
                            $('#centerMenuContent').removeClass('sidebarPage');
                            $('body').removeClass('locked');
                            if(!$('html').hasClass('touch')) {
                                util.lockScrolling(false, '#sideMenu .menuWrap');
                            }
                            setTimeout($.proxy(function () {
                                $('#mainMenu').hide();
                                $('#mainMenu').removeClass('closing');
                                if (this.getConfig().mode == 'full') {
                                    if(this.getConfig().openRoutes.indexOf(window.location.hash.substr(1).split('/')[0]) > -1) {
                                        window.location.hash = '';
                                    }
                                }
                            }, this),1000);
                        } else {

                            if($('#mainMenu').hasClass('closing')) {
                                return;
                            }

                            $('#mainMenu').show();
                            $('.dashboard-footer-menu').fadeIn();
                            $('body').addClass('locked');
                            $('.dashboardToggle').addClass('open');
                            $('.dashboard-menu-text').text('close');
                            $('.daysToRegister').addClass('mobileNavVisible');
                            $('.hamburger-to-close').addClass('changeclose');
                            $('.navbarWrap').addClass('move');
                            $('.navbar .navbar-header').addClass('hideNav');
                            if(!$('html').hasClass('touch')) {
                                util.lockScrolling(true, '#sideMenu .menuWrap');
                            }
                            setTimeout($.proxy(function () {
                                $('#mainMenu').addClass('open');
                                //$('.navbarWrap').addClass('slideDownIn');
                                if (this.getConfig().pushPageContent && this.getConfig().pushPageContent == 'left') {
                                    $('.singlePageWrap').addClass('pushContentLeft');
                                } else if (this.getConfig().pushPageContent && this.getConfig().pushContent == 'right') {
                                    $('.singlePageWrap').addClass('pushContentRight');
                                }
                            }, this), 30);
                        }
                    }

                } else {
                    // TODO - Refactor this into the modal methods
                    $('body').append($(templates.actionmodal({
                        content: content
                    })).modal());
                }

                // Pause any videos that are currently playing
                $('video').each(function (key, videoEl) {
                    $(videoEl).get(0).pause();
                });

                forms.refreshFormHandlers();

            },

            initMenuHover: function (data) {
                // Add tooltip dropdown support to the menu
                var topMenuHtml = $('<ul></ul>');
                // Add the top title that opens the mainmenu
                topMenuHtml.append($('<h5>Menu Dashboard</h5>').click($.proxy(function (e) {
                    this.updateToggleMenu(true, false);
                }, this)));
                $.each(data, function (index, topLink) {
                    if (topLink.hovermenu) {
                        topMenuHtml.append($('<li><a href="' + topLink.link + '">' + topLink.text + '</a></li>'));
                    }
                });
                $('.dashboardToggle > a').hover(function () {
                    $(this).focus();
                    $(this).mouseleave(function (e) {
                        var target = e.toElement || e.relatedTarget;
                        if (!$(target).hasClass('popover') && $(target).parents('.popover').length == 0
                            && !$(target).hasClass('navbar')) {
                            $('#mainNavbar .popover').fadeOut();
                        }
                    });
                    $('#mainNavbar').find('.popover').mouseleave(function () {
                        $('#mainNavbar .popover').fadeOut();
                    });
                }).popover({
                    content: topMenuHtml[0],
                    html: true,
                    placement: 'bottom',
                    container: 'nav',
                    trigger: 'focus',
                    delay: {
                        show: 0,
                        hide: 500
                    }
                });

            },

            routeDashboardLinks: function () {

                if (this.getConfig().mode != 'full') {
                    return; // Only used on full main main (not used when modal forms are enabled)
                }

                this.updateToggleMenu(true, templates.dashboardlinks());
                $('#actionMenu').toggleClass('dashboardLinksShown', true);
                // If the user is logged in, update the days left to submit and logout link
                $('#mainNavbar a[href*="login"]').text('Logout').attr('href', '/logout.aspx');
                if (config.rampitSubTimeLeft >= 0) {
                    $('#mainNavbar a[href*="register"]').html('<span class="dayLeft"></span> Days to Submit').attr('href', '#');
                }
            },

            routeRegister: function () {

                if (this.getConfig().mode != 'full') {
                    return; // Only used on full main main (not used when modal forms are enabled)
                }

                if (user.checkRole('loggedin')) {
                    this.updateToggleMenu(true);
                    return;
                }

                $('#actionMenu').toggleClass('loginShown hasMessage largeSuccess', false);
                $('#sideMenu').addClass('mobAway');

                if (config.rampitRegTimeLeft < 1) {
                    this.updateToggleMenu(true, templates.validationmessage({
                        message: (config.regConfig ? (config.regConfig.closeMessage || '') : ''),
                        messageTitle: (config.regConfig ? (config.regConfig.closeTitle || '') : ''),
                    }));
                    $('#actionMenu').toggleClass('regClosed', true);
                    $('#centerMenuContent').prepend('<i class="material-icons register-login-forms-close">close</i>');
                } else {
                    this.updateToggleMenu(true, templates.register(config.regConfig));
                    $('#actionMenu').toggleClass('registerShown', true);
                }
                this.setFormComponent();
                this.closeLoginRegister();
                
            },

            routeLogin: function () {

                if (this.getConfig().mode != 'full') {
                    return; // Only used on full main main (not used when modal forms are enabled)
                }

                if (user.checkRole('loggedin')) {
                    this.updateToggleMenu(true);
                    return;
                }

                $('#actionMenu').toggleClass('registerShown hasMessage largeSuccess', false);
                $('#actionMenu').toggleClass('loginShown', true);
                $('#sideMenu').addClass('mobAway');

                if (config.regConfig.type == 'expired') {
                    this.updateToggleMenu(true, templates.validationmessage({
                        message: 'Login Expired'
                    }));
                } else if (util.getParameterByName('token').length) {
                    this.updateToggleMenu(true, templates.resetpassword()); // TODO - Update this to use the module form
                } else {
                    this.updateToggleMenu(true, templates.login(config.regConfig));
                }
                this.setFormComponent();
                this.closeLoginRegister();

            },


            routeForgot: function () {

                if (this.getConfig().mode != 'full') {
                    return; // Only used on full main main (not used when modal forms are enabled)
                }

                if (user.checkRole('loggedin')) {
                    this.updateToggleMenu(true);
                    return;
                }

                $('#sideMenu').addClass('mobAway');
                this.updateToggleMenu(true, templates.forgotpassword());
                this.setFormComponent();
                this.closeLoginRegister();
            },

            routeReset: function () {

                if (this.getConfig().mode != 'full') {
                    return; // Only used on full main main (not used when modal forms are enabled)
                }

                $('#sideMenu').addClass('mobAway');
                this.updateToggleMenu(true, templates.resetpassword());
                this.setFormComponent();
                this.closeLoginRegister();
            },

            setFormComponent: function() {
                if(this.getConfig().hideMenuOnForms) {
                    $('#sideMenu').hide();
                    $('#centerMenuContent').css('width','auto');
                }
            },
            
            closeLoginRegister: function() {
            	$('#mainMenu .register-login-forms-close').on('click',$.proxy(function(e){
                	$('#mainMenu .closeWrap').trigger('click');
                },this));
            }
        }
    });
});
